import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

import {
  Button,
  MessageNotification,
  PageHeader,
  Tooltip,
} from 'mailup-web-components'

import { evalCondition } from 'mailup-react-helpers'

import { useNavigate } from 'react-router-dom'

import { TopMenuConfig } from '../../config/TopMenuConfig'

const ContentHeaderComponent = (props) => {
  const {
    pageTitle,
    breadcrumbItems,
    actionConfig = {},
    /* errorCallback, */ topMenuConfigId,
    topMenuActiveId,

    conditionEvaluatorApi,
    showCtaAction,
    loading,
  } = props
  const {
    actionLabel,
    actionClassName,
    actionUrl,
    actionCallback,
    actionDisabled,
  } = actionConfig

  const intl = useIntl()
  const navigate = useNavigate()

  const actionCompClassName = classNames(actionClassName, {
    'button-primary': true,
  })

  const intlBreadcrumbItems = breadcrumbItems.map((item) => {
    return Object.assign(item, {
      label: intl.formatMessage({ id: item.label, defaultMessage: item.label }),
      onClick: useCallback(() => navigate(item.route), [item.route]),
    })
  })

  const topMenuClickHandler = (clickedPageId) => {
    if (clickedPageId !== topMenuActiveId) {
      //  notify to parent
      const navMenuId = TopMenuConfig[topMenuConfigId][clickedPageId].NavMenuId
      if (navMenuId) {
        //  setMenuItem(navMenuId)
      }

      Object.keys(TopMenuConfig[topMenuConfigId]).forEach((pageId) => {
        const item = TopMenuConfig[topMenuConfigId][pageId]
        if (pageId === clickedPageId && item.route) {
          navigate(item.route)
        }
      })
    }
  }

  const menuItems = useMemo(() => {
    if (!TopMenuConfig[topMenuConfigId]) {
      return undefined
    }

    const res = Object.keys(TopMenuConfig[topMenuConfigId]).reduce(
      (acc, key) => {
        const menuItem = TopMenuConfig[topMenuConfigId][key]

        if (
          !menuItem.visibilityCondition ||
          (menuItem.visibilityCondition &&
            evalCondition(menuItem.visibilityCondition))
        ) {
          if (menuItem.Url) {
            return [
              ...acc,
              {
                label: intl.formatMessage({
                  id: menuItem.LabelLangId,
                  defaultMessage: menuItem.LabelLangId,
                }),
                href: menuItem.Url,
                isActive: topMenuActiveId === key,
              },
            ]
          } else {
            return [
              ...acc,
              {
                label: intl.formatMessage({
                  id: menuItem.LabelLangId,
                  defaultMessage: menuItem.LabelLangId,
                }),
                isActive: topMenuActiveId === key,
                onClick: () => topMenuClickHandler(key),
                callbackData: key,
              },
            ]
          }
        }

        return acc
      },
      []
    )

    return res
  }, [TopMenuConfig, topMenuConfigId, topMenuActiveId])

  const ControlsComponent = () => {
    return actionLabel && showCtaAction ? (
      <Button
        kind='primary'
        size='lg'
        disabled={actionDisabled}
        className={actionCompClassName}
        onClick={actionCallback}
      >
        {intl.formatMessage({ id: actionLabel, defaultMessage: actionLabel })}
      </Button>
    ) : undefined
  }

  return (
    <>
      <MessageNotification />
      <Tooltip />
      <PageHeader
        title={pageTitle}
        breadcrumbsItems={intlBreadcrumbItems}
        menuItems={menuItems}
        loading={loading}
        ControlsComponent={ControlsComponent}
      />
    </>
  )
}

ContentHeaderComponent.defaultProps = {
  pageTitle: ' ',
  breadcrumbItems: [],
  showCtaAction: false,
  loading: false,
}

ContentHeaderComponent.propTypes = {
  pageTitle: PropTypes.node,
  breadcrumbItems: PropTypes.array,

  loading: PropTypes.bool,
}

export const ContentHeader = ContentHeaderComponent
